import $ from "jquery";
import NavigationDropdown from "NavigationDropdown";

export default function handleNavigation() {

    let $body = $('body');

    $body.on('click', '.js-toggle-navigation', function () {

        if ($body.is('.show-mobile-navigation')) {
            $body.removeClass('show-mobile-navigation');
        } else {
            $body.addClass('show-mobile-navigation');
        }

        return false;
    }).on('click', '.js-mobile-dropdown', function () {

        let $this = $(this);
        let $dropdown = $this.siblings('.dropdown');

        if ($dropdown.is('.dropdown--active')) {
            $this.removeClass('navigation__dropdown-btn--active');
            $dropdown.removeClass('dropdown--active');
            $dropdown.stop().slideUp(300);
        } else {
            $this.addClass('navigation__dropdown-btn--active');
            $dropdown.addClass('dropdown--active');
            $dropdown.stop().slideDown(300);
        }

        return false;
    });

    new NavigationDropdown();

    $(window).on('scroll', function () {
        $('body').toggleClass('sticky-nav', window.scrollY > 0);
    });
    $('body').toggleClass('sticky-nav', window.scrollY > 0);
}
